
import { Component, OnInit, Output, Input, SimpleChanges, OnChanges, EventEmitter } from '@angular/core';
import { Organization } from './model/Organization';
import { OrgeditService } from './service/orgedit.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { PersonOrganization } from '@src/app/components/footer/model/personorganization';
import { AuthorizationService } from '@src/app/helpers/authorization.service';



import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgedit',
  templateUrl: './orgedit.component.html',
  styleUrls: ['./orgedit.component.css']
})
export class OrgeditComponent implements OnInit,OnChanges {
  @Output() orgList: PersonOrganization[];
  public orgNames: Array<string>= ['No orgs','mmnn'];
  @Output() showOrgList:string;
  selectedFiles: FileList;
  selectedFileName: string;
  searchorglist ='collapsed';
  searchorgimg2 ='visible';
  searchorgimg = '~/assets/images/material-icons/arrow-down-ex.png';
  orgeditmember = 'collapsed';
  labeltest = 'nothing';
  labelvis = "collapsed"
  @Input() modal:boolean;
  @Output() orgeditstatus:string;
  @Output() org:Organization;
  @Output() readonly:boolean = true;
  @Output() editstate:string = "";
  @Output() editicon:string ="edit";
  @Output() editmessage:string ="Click to Edit";
  @Output() editclass:string = "";
  @Output() editclassicon:string =""; 
  @Output() editclassh6:string ="";
  @Output() editclasstextarea:string="";
  @Output() editclassicon1:string="keyboard_arrow_up";
  @Output() editmouseovermessage:string="View information on ";
  @Input() orgId:string;
  @Output() orgClicked = new EventEmitter<Organization>();
  timetosave:number = 0;
  et_admin:boolean = false;
  constructor(
    private route:ActivatedRoute,
    private orgeditsrv:OrgeditService,
    private router:Router
  ) {}

  ngOnInit() {
    this.org = new Organization;
    if(SessionHelper.getPerson()){
      const person = JSON.parse(SessionHelper.getPerson()) ;
    this.et_admin = person.et_admin;
    }
    this.org.organizationId = SessionHelper.getChoosenOrg();
    if(this.route.snapshot.paramMap.get('organizationId')){
      this.orgeditsrv.getOrg(this.route.snapshot.paramMap.get('organizationId')).pipe(untilDestroyed(this)).subscribe(org => {
        this.org = org; 
      });
    }else{
      
      this.orgeditsrv.getOrg(SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(org => {
        this.org = org; 
      });

    }    
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.orgId && changes.orgId.currentValue){
       this.orgeditsrv.getOrg(changes.orgId.currentValue).pipe(untilDestroyed(this)).subscribe(org => {
      this.org = org; 
    });
    }
   
  }

  toggleDisplay() {
    if(this.searchorglist == 'visible'){
      this.searchorglist ='collapsed'
      this.searchorgimg ='~/assets/images/material-icons/arrow-down-ex.png';
      this.searchorgimg2 ='visible';
      this.orgeditmember = 'collapsed';
    }else{
      this.searchorgimg2 ='collapsed';
      this.searchorglist = 'visible'
      this.searchorgimg ='~/assets/images/material-icons/arrow-up-ex.png';
      this.orgeditmember = 'visible';
    }
  }
  onChange(){
      // Wait 1500 ms after last change before saving
      this.timetosave = this.timetosave +1;
      setTimeout(()=>{ 
        this.timetosave = this.timetosave -1;
        if(this.timetosave==0){
          this.orgeditsrv.updateOrg(this.org).pipe(untilDestroyed(this)).subscribe(pers => {
            this.editstate = " - Your changes are saved!";
            this.refreshCachedOrgModules();
          });
        }else{
          this.editstate = " - Saving...";
        }
      } ,1500);
    
    
  }
  // sessionStorage's personorgs (SessionHelper.hasModule, top-nav's setModules)
  // is only ever written at login/org-creation — never refreshed when an
  // existing org's modules are edited here, so a saved change (e.g. enabling
  // timereg) silently doesn't take effect until the next login. Patch the
  // cached copy in place so it does.
  private refreshCachedOrgModules(){
    try{
      const raw = JSON.parse(SessionHelper.getPersonOrgs() || '[]');
      const orgs = Array.isArray(raw) ? raw : [raw];
      const updated = orgs.map((o: any) =>
        o && o.organizationId == this.org.organizationId ? { ...o, modules: this.org.modules } : o
      );
      SessionHelper.setPersonOrgs(JSON.stringify(updated));
    }catch(_error){
      // Best-effort cache refresh; a re-login still picks up the change.
    }
  }
  toggleReadonly(){
    if(this.readonly == true){
      this.readonly = false;
      this.editstate = " - Edit enabled";
      this.editicon = "save_alt";
      this.editmessage ="Click to Save Changes";
      this.editclass = "input-person-custom";
      this.editclassh6 ="data_custom_person";
      this.editclasstextarea ="textarea-person-custom";
      this.editclassicon ="editclassicon_active";
      this.editclassicon1 ="keyboard_arrow_down";
      this.editmouseovermessage ="Close Information on";
    }else{
      this.editmessage ="";
      this.editicon = "edit";
      this.readonly = true;
      this.editstate = "";
      this.editclass="";
      this.editclassh6="";
      this.editclassicon="";
      this.editclasstextarea ="";
      this.editclassicon1 ="keyboard_arrow_down";
      this.editmouseovermessage ="View information on ";
    }
    return this.readonly;
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.selectedFileName =this.selectedFiles.item(0).name;
    }

}

  